import { Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const AddressTitleField = () => {
    const { t } = useTranslation(`signup`)
    return (
        <Typography variant="body1" paddingTop={2}>
            <strong>{ t(`address_title`) }</strong>
        </Typography>
    )
}

export { AddressTitleField }